namespace Matrix.Data {
    export interface DataVisualsRow {
        Id?: number;
        VisualName?: string;
        VisualKey?: string;
        Category?: string;
        Permission?: string;
        Url?: string;
        IsActive?: number;
    }

    export namespace DataVisualsRow {
        export const idProperty = 'VisualKey';
        export const nameProperty = 'VisualName';
        export const localTextPrefix = 'Data.DataVisuals';
        export const deletePermission = 'Administration:Visuals';
        export const insertPermission = 'Administration:Visuals';
        export const readPermission = 'Read:Visuals';
        export const updatePermission = 'Administration:Visuals';

        export declare const enum Fields {
            Id = "Id",
            VisualName = "VisualName",
            VisualKey = "VisualKey",
            Category = "Category",
            Permission = "Permission",
            Url = "Url",
            IsActive = "IsActive"
        }
    }
}
